/* Volti Games — "Comprar ahora" en tarjetas con variantes: abre el selector (Primaria recomendada / Secundaria) antes de agregar */
(() => {
  const d = document;
  const btnOf = pk => pk && pk.parentElement ? pk.parentElement.querySelector('[data-pick]') : null;
  const close = (pk, focus) => {
    if (!pk || pk.hidden) return;
    pk.hidden = true;
    const b = btnOf(pk); if (b) { b.setAttribute('aria-expanded', 'false'); if (focus) b.focus({ preventScroll: true }); }
    const c = pk.closest('.card'); if (c) c.classList.remove('is-picking');
  };
  const closeAll = except => d.querySelectorAll('.pick:not([hidden])').forEach(p => { if (p !== except) close(p); });
  d.addEventListener('click', e => {
    const t = e.target.closest('[data-pick]');
    if (t) {
      e.preventDefault();
      const pk = t.parentElement.querySelector('.pick'); if (!pk) return;
      const opening = pk.hidden; closeAll(pk);
      if (!opening) { close(pk); return; }
      pk.hidden = false; t.setAttribute('aria-expanded', 'true');
      const c = pk.closest('.card'); if (c) c.classList.add('is-picking');
      const first = pk.querySelector('.pick__o:not([disabled])'); if (first) first.focus({ preventScroll: true });
      return;
    }
    if (e.target.closest('[data-pick-close]')) { close(e.target.closest('.pick'), true); return; }
    const o = e.target.closest('.pick [data-buy]');
    if (o) {
      const pk = o.closest('.pick'), b = btnOf(pk);
      setTimeout(() => close(pk), 350);
      if (b) { b.classList.add('ok'); setTimeout(() => b.classList.remove('ok'), 1800); }
      return;
    }
    if (!e.target.closest('.pick')) closeAll();
  });
  d.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const pk = d.querySelector('.pick:not([hidden])'); if (pk) close(pk, true);
  });
})();